const { cxt } = require('./context');

const {
  sales,
} = require('../schema');

const {
  client
} = sales;

/**
 * Validates the VX Client address from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxAddressValidator = [
  cxt('schema', { schema: client.address }),
];

module.exports = {
  salesVxClientAddress: salesVxAddressValidator,
};
